function Hero({ heroHighlight, spinResult, spinning, onSpin }) {
  return (
    <header className="hero">
      <div className="hero-glow" />
      <div>
        <p className="eyebrow">Entertainment Hub + Party Assistant</p>
        <h1>Bring friends together, easily and playfully</h1>
        <p className="sub">
          Offline-friendly entertainment board: movie/playlist/game ideas plus live mini games, random wheel, and truth or
          dare to spark the vibe in one tap.
        </p>
        <div className="hero-tags">
          <span className="chip">Local data</span>
          <span className="chip">Atmospheric UI</span>
          <span className="chip">{heroHighlight}</span>
        </div>
      </div>
      <div className="hero-card">
        <div className="hero-card-title">What should we play tonight?</div>
        <div className="hero-card-grid">
          <div className="mini-card">🎬 Movie picks</div>
          <div className="mini-card">🎵 Vibe playlists</div>
          <div className="mini-card">🎲 Party tools</div>
          <div className="mini-card">🃏 Card icebreakers</div>
        </div>
        <button className="primary ghost" onClick={onSpin} disabled={spinning}>
          {spinning ? 'Spinning...' : 'Surprise me'}
        </button>
        <div className="hero-result">{spinResult || 'Tap to start'}</div>
      </div>
    </header>
  );
}

export default Hero;

